// const PouchDB = require("pouchdb").default;
// PouchDB.plugin(require('pouchdb-find').default);

import { Activite } from "@/models/Activite";
import { Etablissement } from "@/models/Etablissement";
import { MobiDocument } from "@/models/MobiDocument";
import { IMemDB } from "./IMemDB";
import { Individu } from '@/models/Individu';
import { VieQuotidienneDocuments } from '@/models/VieQuotidienneDocument';
import { AutorisationsIndividu } from '@/models/AutorisationsIndividu';
import { Autorisations } from '@/models/Autorisations';
import { Inscription } from '@/models/Inscription';
import { TarifEventSchedulerActiviteDocument } from '@/models/TarifEventSchedulerActiviteDocument';
import { PlageFonctionnementDocument } from '@/models/PlageFonctionnementDocument';
import { ElementFriseActiviteDocument } from '@/models/ElementFriseActiviteDocument';
import { TarifActiviteDocument } from '@/models/TarifActiviteDocument';
import { PointageInoeDocument } from '@/models/PointageInoeDocument';
import { PointageDetailInoeDocument } from '@/models/PointageDetailInoeDocument';
import { PaletteEnfantANDocument } from '@/models/PaletteEnfantANDocument';
import { PaletteCategorieActiviteDocument } from '@/models/PaletteCategorieActiviteDocument';
import { PaletteDocument } from '@/models/PaletteDocument';
import { TarifActiviteElementFriseDocument } from '@/models/TarifActiviteElementFriseDocument';
import { GroupeActivite } from '@/models/GroupeActivite';
import { GroupeIndividu } from '@/models/GroupeIndividu';
import { Parent } from '@/models/Parent';
import { Famille } from '@/models/Famille';
import { AdresseListeDocument } from '@/models/AdresseListeDocument';
import { Ville } from '@/models/Ville';
import { LienIndParDocument } from '@/models/LienIndParDocument';
import { LabelLienDocument } from '@/models/LabelLienDocument';
import { DossierDocument } from '@/models/DossierDocument';
import { MedecinDocument } from '@/models/MedecinDocument';
import { IndividuMaladieDocument } from '@/models/IndividuMaladieDocument';
import { MaladieDocument } from '@/models/MaladieDocument';
import { IndividuAllergieDocument } from '@/models/IndividuAllergieDocument';
import { AllergieDocument } from '@/models/AllergieDocument';
import { VaccinDocument } from '@/models/VaccinDocument';
import { IndividuVaccinDocument } from '@/models/IndividuVaccinDocument';
import { InformationIndividuDocument } from '@/models/InformationIndividuDocument';
import { ChampLibreResultDocument } from '@/models/ChampLibreResultDocument';
import { FamilleChampLibreResultDocument } from '@/models/FamilleChampLibreResultDocument';
import { IndividuChampLibreResultDocument } from '@/models/IndividuChampLibreResultDocument';
import { ChampLibreDocument } from '@/models/ChampLibreDocument';
import { ChampLibreValeurDocument } from '@/models/ChampLibreValeurDocument';
import { ChampLibreResultValeurDocument } from '@/models/ChampLibreResultValeurDocument';
import { TypeActivite } from '@/models/TypeActivite';
import { NiveauScolaireDocument } from '@/models/NiveauScolaireDocument';
import { HistoScolarite } from '@/models/HistoScolarite';
import { SupplementPointageDocument } from '@/models/SupplementPointageDocument';
import { AutorisationEtablissement } from "@/models/AutorisationEtablissement";
import { VieQuoRegimeAliDocument } from "@/models/VieQuoRegimeAliDocument";
import { HistoGroupeDocument } from "@/models/HistoGroupeDocument";
import { ClasseScolaireDocument } from '@/models/ClasseScolaireDocument';
import { EtablissementScolaireDocument } from '@/models/EtablissementScolaireDocument';
import { EnseignantScolaireDocument } from '@/models/EnseignantScolaireDocument';
import { AnneeScolaireDocument } from '@/models/AnneeScolaireDocument';
import { EtablissementScolaireNiveauDocument } from '@/models/EtablissementScolaireNiveauDocument';
import { ClasseScolaireNiveauDocument } from '@/models/ClasseScolaireNiveauDocument';
import { ClasseScolaireEnseignantDocument } from '@/models/ClasseScolaireEnseignantDocument';

// import * as PouchDB from 'pouchdb';
export class MemDB implements IMemDB {
    public localDB: any;
    public docs: any;

    public constructor(db: any) {
        this.localDB = db;
    }
    public loadChanges(info: Array<any>): void {
        let me = this;
        this.upsertDocuments(info);
    }
    public load(): Promise<any> {
        let me = this;
        me.docs = [];
        return new Promise(function (resolve, reject) {
            me.loadAllDocs(function (rows: any) {
                me.docs = me.insertDocuments(rows);
                setTimeout(() => { resolve(me.docs); }, 5000);
            });
            // me.localDB.allDocs({
            //     include_docs: true,
            //     attachments: false,

            // }).then((docs: any) => {
            //     {
            //         me.docs = me.insertDocuments(docs.rows);
            //         setTimeout(() => { resolve(me.docs); }, 5000);
            //     }

            // })
        })
    }
    public loadAllDocs(callback: any) {
        let me = this;
        let name = "_pouch_" + me.localDB.name;
        let openRequest = indexedDB.open(name);
        openRequest.onerror = function () {
            console.error("Error", openRequest.error);
            alert("indxeddb connexion error")
        };
        openRequest.onsuccess = function () {
            let db = openRequest.result;
            let transaction = db.transaction("by-sequence", "readonly");
            let store = transaction.objectStore("by-sequence");
            store.getAll().onsuccess = function (event: any) {
                let version: any;
                let upgrade:any;
                console.log(event.target.result.length);
                let myArray: Array<any> = event.target.result;
                let filteredArray = myArray.reduce((acc: Map<String, any>, curr: any) => {
            
                    
                    if ((curr._deleted as boolean)) {
                        return acc;
                    }
                    let splitedIdRev = (curr._doc_id_rev as string).split("::");
                    let _idCurrent = splitedIdRev[0];
                    let _revCurrent = splitedIdRev[1];
                   
                    
                    if (!acc.get(_idCurrent)) {
                        acc.set(_idCurrent,curr);
                        if(acc.get(_idCurrent) !== curr){
                          console.error(_idCurrent)
                        }
      
                    } else {
                       
                        let _revOld = (acc.get(_idCurrent)._doc_id_rev as string).split("::")[1];
                   
                        acc.set(_idCurrent, 
                         parseInt(_revCurrent.split('-')[0]) >
                         parseInt(_revOld.split('-')[0]) ?
                         curr : acc.get(_idCurrent));
                    }
                    if (_idCurrent === 'version')
                        version = acc.get(_idCurrent);
                    else
                     if (_idCurrent === 'upgrade')
                        upgrade = acc.get(_idCurrent);
                    if(acc.get(_idCurrent) && acc.get(_idCurrent).typedoc==='IndividuDocument'){
                        //console.log(acc[_idCurrent]._id)
                    }
                   
                    return acc;
                }, new Map());
      
                localStorage.setItem("version", JSON.stringify(version))
                if(upgrade)
                localStorage.setItem("upgrade",  JSON.stringify(upgrade))
                
                let arrayOfValues =[...filteredArray.values()]
                    arrayOfValues = arrayOfValues.filter((item: any) => {
                    if(!item) return false;
                    if(item.id==234085){
                      console.log("**************")
                      console.log(item)
                    }
                    if (version.versionMobi === 'v3.0.0')
                     
                        if (typeof item.checksum === 'undefined' || item.checksum === '0'){
                          if(item.typedoc==='IndividuDocument'){
                            console.log("????")
                            console.log(item)
                          }
                         
                          return false;
                        }
                            
                    return true;
                })
                console.log("all docs size: " + arrayOfValues.length);
                callback(arrayOfValues)
            };
        }
    }
    private upsertDocuments(rows: any): any {
        rows.forEach((row: any) => {
            let typedoc = "";
            if (typeof row.typedoc !== 'undefined')
                typedoc = row.typedoc;
            else
                typedoc = (row._id as string).split("_")[0];

            if (typeof this.docs[typedoc] !== "undefined") {
                let i = this.docs[typedoc].findIndex((item: any) => item._id === row._id);
                if (i !== -1) {
                    if (typeof row._deleted === "undefined" || !row._deleted)
                        this.docs[typedoc][i] = this.createDocument(row);
                    else
                        this.docs[typedoc].splice(i, 1);
                } else {
                    if (typeof row._deleted === "undefined" || !row._deleted)
                        this.docs[typedoc].push(this.createDocument(row));
                }
            }
        });
        return this.docs;
    }
    // OLD
    //  private upsertDocuments(rows: any): any {
    //     rows.forEach((row: any) => {
    //         // TODO : check if the row exist then...
    //         let i = this.docs[row.typedoc].findIndex((item: any) => item._id === row._id);
    //         if (i !== -1) {
    //             //Supprime l'ancien
    //             this.docs[row.typedoc].splice(i, 1);

    //             //Ajouter nouveau si c'est un update
    //             if (typeof row._deleted === "undefined" || !row._deleted)
    //                 this.docs[row.typedoc].push(this.createDocument(row));
    //         } else {
    //             if (typeof row._deleted === "undefined" || !row._deleted)
    //                 this.docs[row.typedoc].push(this.createDocument(row));
    //         }
    //     });
    //     return this.docs;
    // }
    private insertDocuments(rows: any): any {
        let docs: any = [];
        docs = (rows as Array<any>).reduce((acc, obj) => {
            let typedoc = obj.typedoc;
            if (typedoc) {
                if (!acc[typedoc])
                    acc[typedoc] = [];
                let splited = (obj._doc_id_rev as string).split("::");
                obj._id = splited[0];
                obj._rev = splited[1];
                acc[typedoc].push(this.createDocument(obj));
            }
            return acc;
        }, {});
        return docs;
    }
    // private insertDocuments(rows: any): any {
    //     let docs: any = [];
    //     rows.forEach((row: any) => {
    //         if (typeof docs[row.doc.typedoc] === 'undefined' || !docs[row.doc.typedoc]) {
    //             docs[row.doc.typedoc] = [];
    //         }
    //         docs[row.doc.typedoc].push(this.createDocument(row.doc));

    //     });
    //     return docs;
    // }

    public createDocument(doc: any): MobiDocument {
        switch (doc.typedoc) {
            case "ActiviteDocument":
                return new Activite(doc).setMemDb(this);
            case "EtablissementDocument":
                return new Etablissement(doc).setMemDb(this);
            case "IndividuDocument":
                return new Individu(doc).setMemDb(this);
            case "VieQuotidienneDocument":
                return new VieQuotidienneDocuments(doc).setMemDb(this);
            case "VieQuoRegimeAliDocument":
                return new VieQuoRegimeAliDocument(doc).setMemDb(this);
            case "AutorisationsIndividuDocument":
                return new AutorisationsIndividu(doc).setMemDb(this);
            case "AutorisationsDocument":
                return new Autorisations(doc).setMemDb(this);
            case "AutorisationEtablissementDocument":
                return new AutorisationEtablissement(doc).setMemDb(this);
            case "InscriptionDocument":
                return new Inscription(doc).setMemDb(this);
            case "TarifEventSchedulerActiviteDocument":
                return new TarifEventSchedulerActiviteDocument(doc).setMemDb(this);
            case "PlageFonctionnementDocument":
                return new PlageFonctionnementDocument(doc).setMemDb(this);
            case "ElementFriseActiviteDocument":
                return new ElementFriseActiviteDocument(doc).setMemDb(this);
            case "TarifActiviteDocument":
                return new TarifActiviteDocument(doc).setMemDb(this);
            case "PointageDocument":
                return new PointageInoeDocument(doc).setMemDb(this);
            case "PointageDetailDocument":
                return new PointageDetailInoeDocument(doc).setMemDb(this);
            case "PaletteEnfantANDocument":
                return new PaletteEnfantANDocument(doc).setMemDb(this);
            case "PaletteCategorieActiviteDocument":
                return new PaletteCategorieActiviteDocument(doc).setMemDb(this);
            case "PaletteDocument":
                return new PaletteDocument(doc).setMemDb(this);
            case "TarifActiviteElementFriseDocument":
                return new TarifActiviteElementFriseDocument(doc).setMemDb(this);
            case "GroupeIndividuDocument":
                return new GroupeIndividu(doc).setMemDb(this);
            case "GroupeActiviteDocument":
                return new GroupeActivite(doc).setMemDb(this);
            case "ParentDocument":
                return new Parent(doc).setMemDb(this);
            case "FamilleDocument":
                return new Famille(doc).setMemDb(this);
            case "AdresseListeDocument":
                return new AdresseListeDocument(doc).setMemDb(this);
            case "VilleDocument":
                return new Ville(doc).setMemDb(this);
            case "LienIndParDocument":
                return new LienIndParDocument(doc).setMemDb(this);
            case "LabelLienDocument":
                return new LabelLienDocument(doc).setMemDb(this);
            case "DossierDocument":
                return new DossierDocument(doc).setMemDb(this);
            case "MedecinDocument":
                return new MedecinDocument(doc).setMemDb(this);
            case "IndividuMaladieDocument":
                return new IndividuMaladieDocument(doc).setMemDb(this);
            case "MaladieDocument":
                return new MaladieDocument(doc).setMemDb(this);
            case "IndividuAllergieDocument":
                return new IndividuAllergieDocument(doc).setMemDb(this);
            case "AllergieDocument":
                return new AllergieDocument(doc).setMemDb(this);
            case "VaccinDocument":
                return new VaccinDocument(doc).setMemDb(this);
            case "IndividuVaccinDocument":
                return new IndividuVaccinDocument(doc).setMemDb(this);
            case "InformationIndividuDocument":
                return new InformationIndividuDocument(doc).setMemDb(this);
            case "ChampLibreResultDocument":
                return new ChampLibreResultDocument(doc).setMemDb(this);
            case "FamilleChampLibreResultDocument":
                return new FamilleChampLibreResultDocument(doc).setMemDb(this);
            case "IndividuChampLibreResultDocument":
                return new IndividuChampLibreResultDocument(doc).setMemDb(this);
            case "ChampLibreDocument":
                return new ChampLibreDocument(doc).setMemDb(this);
            case "ChampLibreValeurDocument":
                return new ChampLibreValeurDocument(doc).setMemDb(this);
            case "ChampLibreResultValeurDocument":
                return new ChampLibreResultValeurDocument(doc).setMemDb(this);
            case "TypeActiviteDocument":
                return new TypeActivite(doc).setMemDb(this);
            case "ClasseScolaireDocument":
                return new ClasseScolaireDocument(doc).setMemDb(this);
            case "EtablissementScolaireDocument":
                return new EtablissementScolaireDocument(doc).setMemDb(this);
            case "EnseignantDocument":
                return new EnseignantScolaireDocument(doc).setMemDb(this);
            case "NiveauScolaireDocument":
                return new NiveauScolaireDocument(doc).setMemDb(this);
            case "HistoScolariteIndividuDocument":
                return new HistoScolarite(doc).setMemDb(this);
            case "SupplementPointageDocument":
                return new SupplementPointageDocument(doc).setMemDb(this);
            case "HistoGroupeDocument":
                return new HistoGroupeDocument(doc).setMemDb(this);
            case "AnneeScolaireDocument":
                return new AnneeScolaireDocument(doc).setMemDb(this);
            case "EtablissementScolaireNiveauDocument":
                return new EtablissementScolaireNiveauDocument(doc).setMemDb(this);
            case "ClasseScolaireNiveauDocument":
                return new ClasseScolaireNiveauDocument(doc).setMemDb(this);
            case "ClasseScolaireEnseignantDocument":
                return new ClasseScolaireEnseignantDocument(doc).setMemDb(this);
            /*case "supplementMobi":
                return new Supplement(doc).setMemDb(this);
            case "pointageMobi":
                return new Pointage(doc).setMemDb(this);*/
            default:
                return new MobiDocument();
        }

    }
    public findAll(filter: any): Array<any> {
        return this.docs[filter.doctype];
    }
    public find(filter: any): Array<any> {
        if (typeof this.docs[filter.doctype] !== 'undefined' || Array.isArray(this.docs[filter.doctype])) {
            return this.docs[filter.doctype].filter((i: any) => i[filter.fkey] === filter.fvalue);
        } else {
            return [];
        }
    }
    public findOne(filter: any, throwError = true): any {
        let doc = this.docs[filter.doctype].find((i: any) => i[filter.fkey] === filter.fvalue);
        if (throwError && typeof doc === 'undefined')
            throw new TypeError(`Document ${filter.doctype} avec la colonne ${filter.fkey} = ${filter.fvalue} introuvable !`);
        return doc;
    }
    public getActivites() {
        return this.docs;
        // return this.docs.rows.filter((item:any)=>item.doc.typedoc=== "ActiviteDocument")
    }

    // MemDB(dbName:String ){
    //     this.localDB=db;
    // }

}
